import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDEfBHcetSA-2V3yEejlihAWFmA2LIydgc",
  authDomain: "r2z2-78a59.firebaseapp.com",
  projectId: "r2z2-78a59",
  storageBucket: "r2z2-78a59.firebasestorage.app",
  messagingSenderId: "477302438364",
  appId: "1:477302438364:web:b2cdda5238e2640662f719",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);